import { createSignal, onCleanup, Show } from "solid-js";

const SKELETON_DELAY = 300;

export function TodoDetailSkeleton() {
  const [show, setShow] = createSignal(false);
  const timer = setTimeout(() => setShow(true), SKELETON_DELAY);
  onCleanup(() => {
    clearTimeout(timer);
  });

  return (
    <Show when={show()}>
      <div class="flex flex-col gap-6 py-4 animate-pulse">
        <div class="flex items-center gap-3">
          <div class="h-6 w-6 rounded border-2 border-muted" />
          <div class="h-8 flex-1 rounded bg-muted/40" />
        </div>
        <div class="grid grid-cols-1 gap-2">
          <div class="h-10 w-full rounded bg-muted/30" />
          <div class="h-10 w-full rounded bg-muted/30" />
          <div class="h-10 w-full rounded bg-muted/30" />
          <div class="h-10 w-full rounded bg-muted/30" />
        </div>
        <div class="h-32 w-full rounded bg-muted/20" />
      </div>
    </Show>
  );
}
